// src/ui/match-card.js
//
// Helper para montar cards del Prode (renderMatchCard de src/modules/prode.js)
// fuera de su pantalla original — manteniendo el aspecto visual idéntico.
//
// Razón: el CSS de las cards (PRODE_CSS) vive dentro del Shadow DOM del Prode
// del grupo. Cuando otro módulo (p.ej. perfil-prode) reusa renderMatchCard y
// vuelca el HTML directo en el DOM principal, las cards salen sin estilo
// (texto plano apilado). Bug B del HANDOFF v3.26 §5.1.
//
// Este helper crea un Shadow DOM aislado con PRODE_CSS adentro, idéntico al
// del Prode, y mete las cards adentro. Resultado: las cards en el perfil se
// ven exactamente como las del Prode del grupo.
//
// NO mueve renderMatchCard ni sus 18+ helpers internos (que leen estado S de
// prode.js). Mover todo eso es refactor mayor — queda como DT-EF para
// post-piloto. Este helper resuelve el síntoma con cero acoplamiento nuevo.

import { PRODE_CSS } from '../modules/prode.js'

// mountMatchCardShadow(targetEl, htmlCards)
//
// Monta `htmlCards` (string HTML con uno o varios `<details class="match">…`
// devueltos por renderMatchCard) dentro de un Shadow DOM aislado con
// PRODE_CSS. `targetEl` es un elemento normal del DOM principal.
//
// Si el host ya tiene un shadowRoot (re-render del mismo host), lo reusa.
// Devuelve el shadow root para que el caller pueda querySelectorear adentro
// si necesita (no es obligatorio).
export const mountMatchCardShadow = (targetEl, htmlCards) => {
  if (!targetEl) return null
  const shadow = targetEl.shadowRoot || targetEl.attachShadow({ mode: 'open' })
  shadow.innerHTML = `<style>${PRODE_CSS}</style>${htmlCards}`
  return shadow
}
